import { Component, OnInit } from '@angular/core';
import { PortalModule } from '@angular/cdk/portal';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { GetAllStatuses } from '@store/app/app.actions';
import { datadogRum } from '@datadog/browser-rum';
import { environment } from '@environments/environment';
import { IdleTimeoutService } from '@services/idle-timeout.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, PortalModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'onmed-fronted';

  constructor(private store: Store, private idleService: IdleTimeoutService) {}

  ngOnInit(): void {
    this.idleService.startWatching();
    this.store.dispatch(new GetAllStatuses());
  }
}

datadogRum.init({
  applicationId: environment.datadog.applicationId,
  clientToken: environment.datadog.clientToken,
  // `site` refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'datadoghq.com',
  service: environment.datadog.service,
  env: environment.datadog.env,
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  defaultPrivacyLevel: 'mask-user-input',
});
